import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { VariantDetailView } from "@/components/dashboard/seller/pages/products/ProductDetailsPage"

export const Route = createFileRoute("/products/variant/$variantId")({
  component: VariantDetailsRoute,
})

function VariantDetailsRoute() {
  const { variantId } = Route.useParams()
  const navigate = useNavigate()

  return (
    <div className="max-w-6xl mx-auto pb-4">
      <VariantDetailView
        variantId={variantId}
        onBack={() => {
          navigate({ to: "/products" })
        }}
      />
    </div>
  )
}
